// extracted by css-extract-rspack-plugin
export default {"cls1":"TasteOfMentionsUpsellCard-cls1_oYw","cls2":"TasteOfMentionsUpsellCard-cls2_Nj2 TasteOfMentionsUpsellCard-cls1_oYw"};